import { useEffect, useState } from "react";
import { Button, Form, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

// 🔹 Animations
import Crown_animation from "../animations/crown_animation/Crown_animation";
import menuAnmination from "../animations/header_lottie_btn_animation/Menu_lottie_btn_animation.json";
import profileAnmination from "../animations/header_lottie_btn_animation/Profile_lottie_btn_animation.json";
import wallateAnmination from "../animations/header_lottie_btn_animation/Wallate_lottie_btn_animation.json";

// 🔹 Common Components
import Header_lottie_btn from "../common_components/common_btn/header_lottie_btn/Header_lottie_btn";
import Yellow_arrow_btn from "../common_components/common_btn/yellow_arrow_btn/Yellow_arrow_btn";

// 🔹 Auth Components
import Login from "../authencation/free_login/login/Login";
import Signup from "../authencation/free_login/signup/Signup";
import Upgread_login from "../authencation/pro_login/upgread_login/Upgread_login";

// 🔹 Offcanvas Menu
import Upgread_header_menu_offcanvas from "./upgread_header_menu_offcanvas/Upgread_header_menu_offcanvas";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  // 🔹 State Management
  const [scrolled, setScrolled] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [expanded, setExpanded] = useState(false);

  // 🔹 Modal States
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showProLogin, setShowProLogin] = useState(false);

  // 🔹 Scroll Effect for Header Background
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 🔹 Navigation Handler
  const handleNavLinkClick = (path) => {
    navigate(path);
    setExpanded(false); // collapse navbar
  };

  return (
    <>
      <section
        className={`header_holder ${location.pathname === "/" ? "home_header_section" : ""
          } ${scrolled ? "header_bg" : ""}`}
      >
        <div className="container">
          <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
            <Navbar.Brand>
              <Link to={"/"}>
              <div className="logo_holder">
                <img
                  src="/assets/images/header/logo.png"
                  alt="logo"
                  className="logo_img"
                />
              </div>
              </Link>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              {/* 🔹 Navbar Links */}
              <Nav className="mx-auto">
                <Nav.Link
                  onClick={() => handleNavLinkClick("/")}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  onClick={() => handleNavLinkClick("/services")}
                  className={location.pathname === "/services" ? "active" : ""}
                >
                  Services
                </Nav.Link>

                {/* <Nav.Link
                  onClick={() => handleNavLinkClick("/explore-game")}
                  className={
                    location.pathname === "/explore-game" ? "active" : ""
                  }
                >
                  Explore
                </Nav.Link> */}

                <Nav.Link
                  onClick={() => handleNavLinkClick("/refer-and-earn")}
                  className={
                    location.pathname === "/refer-and-earn" ? "active" : ""
                  }
                >
                  Refer & Earn
                </Nav.Link>

                <Nav.Link
                  onClick={() => handleNavLinkClick("/contact-us")}
                  className={
                    location.pathname === "/contact-us" ? "active" : ""
                  }
                >
                  Contact Us
                </Nav.Link>
              </Nav>

              {/* 🔹 Desktop View Buttons */}
              {/* <div className="desktop_veiw_menu">
                <Form className="header_btn_holder">
                  <Header_lottie_btn
                    animationData={wallateAnmination}
                    onClick={() => navigate("/recharge-wallate")}
                  />
                  <Header_lottie_btn
                    animationData={profileAnmination}
                    onClick={() => navigate("/profile")}
                  />
                  <div onClick={() => setShowMenu(true)}>
                    <Header_lottie_btn animationData={menuAnmination} />
                  </div>
                  <Yellow_arrow_btn
                    btnText="Get Started"
                    onClick={() => setShowLogin(true)}
                  />
                  <Button
                    className="Upgrade_Now_btn"
                    onClick={() => setShowProLogin(true)}
                  >
                    Upgrade Now <Crown_animation />
                  </Button>
                </Form>
              </div> */}
            </Navbar.Collapse>
          </Navbar>
        </div>

        {/* 🔹 Mobile View */}
        {/* <div className="mobile_veiw_menu">
          <div className="container">
            <Form className="header_btn_holder">
              <Header_lottie_btn
                animationData={wallateAnmination}
                onClick={() => navigate("/recharge-wallate")}
              />
              <Header_lottie_btn
                animationData={profileAnmination}
                onClick={() => navigate("/profile")}
              />
              <div onClick={() => setShowMenu(true)}>
                <Header_lottie_btn animationData={menuAnmination} />
              </div>
              <Yellow_arrow_btn
                btnText="Get Started"
                onClick={() => setShowLogin(true)}
              />
              <Button
                className="Upgrade_Now_btn"
                onClick={() => setShowProLogin(true)}
              >
                Upgrade Now <Crown_animation />
              </Button>
            </Form>
          </div>
        </div> */}
      </section>

      {/* 🔹 Offcanvas Menu */}
      {/* <Upgread_header_menu_offcanvas
        show={showMenu}
        handleClose={() => setShowMenu(false)}
      /> */}

      {/* 🔹 Modals */}
      {/* <Login
        show={showLogin}
        onHide={() => setShowLogin(false)}
        onSignupClick={() => {
          setShowLogin(false);
          setShowSignup(true);
        }}
      />
      <Signup
        show={showSignup}
        onHide={() => setShowSignup(false)}
        onLoginClick={() => {
          setShowSignup(false);
          setShowLogin(true);
        }}
      />
      <Upgread_login
        show={showProLogin}
        onHide={() => setShowProLogin(false)}
      /> */}
    </>
  );
}

export default Header;
